import getDFPBlock from "../utils/getDFPBlock";

export default function (newsIndex) {
    let advPlacesOnPages = document.querySelectorAll('.adv-between-newses:not(.inited)');
    if (advPlacesOnPages != null && advPlacesOnPages.length > 0) {
        let advPlace = advPlacesOnPages[0];
        let wrapperId = 'adv-between-newses' + newsIndex;
        advPlace.id = wrapperId;

        if (newsIndex <= 5) {
            if (window.innerWidth < 640) {
                getDFPBlock('/56301415/24tv_between_news_mobile_(2-5)', [[1, 1], [300, 250]], wrapperId, '300px', function () {
                    advPlace.classList.add('inited');
                });
            } else {
                getDFPBlock('/56301415/24tv_between_news_desktop_(2-5)', [[1, 1], [580, 400]], wrapperId, '100%', function () {
                    advPlace.classList.add('inited');
                });
            }
        } else {
            if (window.innerWidth < 640) {
                getDFPBlock('/56301415/24tv_between_news_mobile_(6-11)', [[1, 1], [300, 250]], wrapperId, '300px', function () {
                    advPlace.classList.add('inited');
                });
            } else {
                getDFPBlock('/56301415/24tv_between_news_desktop_(6-11)', [[1, 1], [580, 400]], wrapperId, '100%', function () {
                    advPlace.classList.add('inited');
                });
            }
        }
    }
}